import { Directive, ElementRef, inject } from '@angular/core';

@Directive({ selector: '[spPanelDragHandler]' })
export class SpPanelDragHandlerDirective {
    private readonly elementRef = inject<ElementRef<HTMLElement>>(ElementRef);
}
